<template>
  <div class="row">
    <div class="flex md12" style="font-size: 15px, color: black">
      <vxe-toolbar>
        <template #buttons>
          <vxe-input
            v-model="filterName_detable"
            type="search"
            placeholder="Input a gene name"
            @keyup="searchEvent_detable"
          ></vxe-input>
          <vxe-button @click="exportDataEvent"
            ><a-icon type="cloud-download" /> Download
          </vxe-button>
        </template>
      </vxe-toolbar>
      <vxe-table
        border
        show-overflow
        :data="tableData_detable"
        row-id="id"
        size="small"
        ref="xTable"
        align="center"
        header-align="center"
        class="my-sort"
        :row-config="{
          isHover: true,
          isCurrent: true,
          isHover: true,
          height: 30,
        }"
        :sort-config="{
          showIcon: false,
          trigger: all,
        }"
        @header-cell-click="headerCellClickEvent"
      >
        <vxe-column field="gene1" title="Gene A" type="html">
          <!-- <template #default="{ row }">
            <a @click="goDrugDetails(row.CMapID, row.dName)">{{ row.dName }}</a>
          </template> -->
        </vxe-column>
        <vxe-column field="gene2" title="Gene B" type="html"></vxe-column>
        <!-- <vxe-column field="pcid" title="Cluster ID" type="html">
          <template #default="{ row }">
            <div
              v-if="row.pcid.startsWith('PC0') && row.pcid != ''"
              style="text-align: center"
            >
              <a-tag
                color="#4572a7"
                @click="goTOpc(row.pcid)"
                onmouseover="this.style.cursor='pointer'"
              >
                {{ row.pcid }}
              </a-tag>
            </div>
            <div v-else><a-tag>no</a-tag></div>
          </template>
        </vxe-column> -->
        <vxe-column field="r" title="R" type="html" sortable>
          <template #header="{ column }">
            <span>{{ column.title }}</span>
            <span class="custom-sort" :class="{ 'is-order': column.order }">
              <i
                :class="[
                  column.order
                    ? `vxe-icon-sort-numeric-${column.order}`
                    : 'vxe-icon-sort',
                ]"
              ></i>
            </span> </template
        ></vxe-column>
        <vxe-column field="pvalue" title="P-value" type="html" sortable>
          <template #header="{ column }">
            <span>{{ column.title }}</span>
            <span class="custom-sort" :class="{ 'is-order': column.order }">
              <i
                :class="[
                  column.order
                    ? `vxe-icon-sort-numeric-${column.order}`
                    : 'vxe-icon-sort',
                ]"
              ></i>
            </span> </template
        ></vxe-column>
      </vxe-table>
      <vxe-pager
        background
        size="small"
        :loading="loading_detable"
        :current-page="tablePage_detable.currentPage"
        :page-size="tablePage_detable.pageSize"
        :total="tablePage_detable.totalResult"
        :page-sizes="[15, 20, 50, 100]"
        :layouts="[
          'PrevPage',
          'JumpNumber',
          'NextPage',
          // 'FullJump',
          'Sizes',
          'Total',
        ]"
        @page-change="handlePageChange_table"
      >
      </vxe-pager>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import XEUtils from "xe-utils";

export default {
  props: ["selectgene"],
  data() {
    return {
      webiste: "http://research.gzsys.org.cn/perturbdb",
      // tableData: [],
      //加载
      spinning: true,
      //全表搜索
      filterName_detable: "",
      tempdata_detable: [],
      //分页
      getdata_detable: null, //必须要生成这个data
      loading_detable: false,
      tableData_detable: [],
      tablePage_detable: {
        currentPage: 1,
        pageSize: 15,
        totalResult: 0,
      },
    };
  },
  watch: {
    selectgene() {
      axios
        .get(
          "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/publications_corNetwork.php",
          {
            params: {
              datasetId: this.$route.query.datasetId,
              gene: this.selectgene,
            },
          }
        )
        .then((response) => {
          // this.tableData_detable = response.data;
          var filteredArray = response.data.filter(function (item) {
            return item.gene2 !== "NT" && item.pvalue <= 0.05;
          });
          this.getdata_detable = filteredArray;
          //this.getdata_detable = response.data;
          this.findList_detable(this.getdata_detable);
          this.tablePage_detable.currentPage = 1; //必须重置到第一页
          this.spinning = false;
        });
    },
  },
  methods: {
    headerCellClickEvent({
      column,
      triggerResizable,
      triggerSort,
      triggerFilter,
    }) {
      // 如果触发了列的其他功能按钮
      console.log(column["field"]);
      if (
        column.sortable &&
        !(triggerResizable || triggerSort || triggerFilter)
      ) {
        if (column.order === "desc") {
          axios
            .get(
              "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/publications_corNetwork.php",
              {
                params: {
                  datasetId: this.$route.query.datasetId,
                  gene: this.selectgene,
                },
              }
            )
            .then((response) => {
              // this.tableData_detable = response.data;
              var filteredArray = response.data.filter(function (item) {
                return item.gene2 !== "NT" && item.pvalue <= 0.05;
              });
              this.getdata_detable = filteredArray;
              //this.getdata_detable = response.data;
              this.$refs.xTable.clearSort();
              this.findList_detable(this.getdata_detable);
              this.tablePage_detable.currentPage = 1; //必须重置到第一页
              this.spinning = false;
            });
        } else if (column.order === "asc") {
          this.$refs.xTable.sort(column.property, "desc");
          var jiangxu = this.getdata_detable.sort(
            (a, b) => b[column.field] - a[column.field]
          ); // 按照 num 属性降序排序
          this.getdata_detable = jiangxu;
          this.findList_detable(this.getdata_detable);
        } else {
          this.$refs.xTable.sort(column.property, "asc");
          var shengxu = this.getdata_detable.sort(
            (a, b) => a[column.field] - b[column.field]
          ); // 按照 num 属升序排序
          this.getdata_detable = shengxu;
          this.findList_detable(this.getdata_detable);
        }
      }
    },
    formatAmount({ cellValue }) {
      return XEUtils.commafy(XEUtils.toNumber(cellValue));
    },
    //扰动群跳转
    goTOpc(value) {
      let href = this.webiste + "/#/pcDetails?pcID=" + value;
      window.open(href, "_blank");
    },
    //页面跳转
    goDrugDetails(value, value2) {
      let routeData = this.$router.resolve({
        name: "drugModelResult",
        query: { drugid: value, dName: value2 },
      });
      window.open(routeData.href, "_blank");
    },
    findList_detable(data) {
      this.loading_detable = true;
      setTimeout(() => {
        const list = data;
        this.loading_detable = false;
        this.tablePage_detable.totalResult = list.length;
        this.tableData_detable = list.slice(
          (this.tablePage_detable.currentPage - 1) *
            this.tablePage_detable.pageSize,
          this.tablePage_detable.currentPage * this.tablePage_detable.pageSize
        );
      }, 300);
    },
    // 分页响应按钮
    handlePageChange_table({ currentPage, pageSize }) {
      this.tablePage_detable.currentPage = currentPage;
      this.tablePage_detable.pageSize = pageSize;
      if (this.tempdata_detable.length == 0) {
        this.findList_detable(this.getdata_detable);
      } else {
        this.findList_detable(this.tempdata_detable);
      }
    },
    //全标查询
    searchEvent_detable() {
      this.tablePage_detable.currentPage = 1; //必须重置到第一页
      const filterName = XEUtils.toValueString(this.filterName_detable)
        .trim()
        .toLowerCase();
      if (filterName) {
        const filterRE = new RegExp(filterName, "gi");
        const searchProps = ["gene2"];
        const rest = this.getdata_detable.filter((item) =>
          searchProps.some(
            (key) =>
              XEUtils.toValueString(item[key])
                .toLowerCase()
                .indexOf(filterName) > -1
          )
        );
        this.tempdata_detable = rest.map((row) => {
          const item = Object.assign({}, row);
          searchProps.forEach((key) => {
            item[key] = XEUtils.toValueString(item[key]).replace(
              filterRE,
              (match) => `${match}`
            );
          });
          return item;
        });
        this.findList_detable(this.tempdata_detable);
      } else {
        this.tempdata_detable = [];
        this.findList_detable(this.getdata_detable);
      }
    },
    // 导出底物蛋白列表
    exportDataEvent() {
      if (this.tempdata_detable.length == 0) {
        const list = this.getdata_detable;
        this.$refs.xTable.exportData({
          filename: this.selectgene + "_all_perturbation_Similarity",
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      } else {
        if (this.filterName_detable == "" || this.filterName_detable == " ") {
          const list = this.getdata_detable;
          this.$refs.xTable.exportData({
            filename: this.selectgene + "_all_perturbation_Similarity",
            type: "csv",
            isHeader: true,
            isFooter: true,
            data: list,
          });
        } else {
          const list = this.tempdata_detable;
          this.$refs.xTable.exportData({
            filename:
              this.filterName_detable + "_related_perturbation_Similarity",
            type: "csv",
            isHeader: true,
            isFooter: true,
            data: list,
          });
        }
      }
    },
  },
};
</script>
<style>
.my-sort .custom-sort {
  padding: 0 4px;
}
.my-sort .custom-sort.is-order {
  color: #409eff;
}
</style>
